<app-multiselect-tags #funcExp class="w-100" [showTagClose]="true"
    [filedName]="label" [hasSelectAll]="true" [autoCompleteList]="dataSource"
    [selectedItems]="selectedValues" (onType)="onType($event)" (onSelect)="selectItem($event)"></app-multiselect-tags>
